module.exports = __webpack_public_path__ + "images/dingtalk/403-5998b74e405ce74e383f74fffeba1924.png";